import { createSlice } from '@reduxjs/toolkit';
import { SpaceState } from './state';
import reducers from './reducers';

const initialState: SpaceState = {
  branches: null,
  favorite_branches: null,
  branch: null,
  regions: null,
  offices: [],
  meta_offices: null,
  meeting_room: null,
  meeting_rooms: null,
  retails: null,
  retail: null,
  remaining_hours: null,
  reservations: null,
};

const space = createSlice({
  name: 'space',
  initialState,
  reducers,
});

export const spaceActions = { ...space.actions };

export default space;
